import styled from 'styled-components'

export const MainHealthProcedureDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90vh;
  max-height: 100%;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 90vh;

  display: flex;
  flex-direction: column;
  padding: 20px;

  hr {
    margin: 15px 0 10px 0;
    border: 1px solid ${props => props.theme.colors.color6b7786};
  }
`
